var map = {
	"./becomeapartner.jpg": "012f",
	"./box.svg": "404f",
	"./customer.svg": "1c56",
	"./engineer.svg": "6520",
	"./guarantee.svg": "ace6",
	"./hand-shake.svg": "044d",
	"./logo.png": "cf05",
	"./miraqleslogo.svg": "e92e",
	"./pdf-file.svg": "71a5",
	"./support.svg": "2621"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";